module.exports = __webpack_public_path__ + "static/img/kit-a-poser.db05223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/kit-a-poser.jpg
// module id = nY8H
// module chunks = 0